import { render, staticRenderFns } from "./RemixLink.vue?vue&type=template&id=d952b976&scoped=true"
import script from "./RemixLink.vue?vue&type=script&lang=js"
export * from "./RemixLink.vue?vue&type=script&lang=js"
import style0 from "./RemixLink.vue?vue&type=style&index=0&id=d952b976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d952b976",
  null
  
)

export default component.exports